const CONSTANTS = {
    our_company: {
        name: "Byte The Code LLC",
        product: "Wellgo.com",
        product_market_name: "Welldugo.com",
        contacts: {
            support: {
                email: "welldugo.btc@gmail.com",
                tel: "+17327999546",
                mobile: "+17327999546",
            }
        }
    },
    language_support: {
        enabled: false,
        default: "ENGLISH"
    },
    currency_support: {
        enabled: false,
        default: "USD"
    },
    viewport_threshold: 1000,
    infant_age_threshold: 5,
    special_str_separator: " [$/*S#_P#_R#T*/$] ",
    round_trip: "ROUND-TRIP",
    one_way: "ONE-WAY",
    duffel: "DUFFEL",
    amadeus: "AMADEUS",
    welldugo: "WELLDUGO",
    dev: "DEVELOPMENT",
    prod: "PRODUCTION",
    default_currency: "USD",
    default_language: "ENGLISH",
    local_storage: {
        wellgo_usr_curr: "wellgo_usr_curr",
        wellgo_usr_lang: "wellgo_usr_lang",
        flight_search_object: "search_obj",
        logged_in_usr: "logged_in_usr",
        product_type: "product_type",
        hotel_search_obj: "hotel_search_obj"
    },
    log_types: {
        activity: "activity",
        warning: "warning",
        error: "error",
        booking_error: "booking-error"
    },
    resource_types: {
        booking_history: "Booking History",
        user_favorites: "User Favorites",
    },
    checkout_pages: {
        app_level_checkout_status: false,
        info: "INFO_PAGE",
        pnr: "PNR_PAGE",
        payment: "PAYMENT_PAGE",
        hotel: {
            guests: "GUESTS_PAGE",
        },
        rental_car: {
            driver_forms: "DRIVER_FORMS_PAGE"
        }
    },
    site_pages: {
        account: "account",
        landing: "home",
        search: "search",
        trips: "trips",
        explore: "explore",
        deals: "deals",
        support: "support",
        password_reset: "password-reset",
        available_airports: "available-airports"
    },
    duffel_checkout: {
        payment: {
            types: {
                balance: "balance",
                arc_bsp_cash: "arc_bsp_cash",
            }
        }
    },
    prices: {
        markup_types: {
            percentage: "percentage",
            flat_rate: "flat_rate"
        },
        markup_percentage: 15,
    },
    app_services_fees: {
        types: {
            all_products: -1,
            flights: 0,
            stays: 1,
            cars: 2,
            packages: 3,
            deals: 4
        }
    },
    independent_agent: {
      transaction: {
        types: {
            wallet_top_up: 1,
            link_created_loaded: 2,
            customer_opened_link: 3,
            view_full_flight_details: 4,
            customer_searched_flight: 5,
            customer_ordered_flight: 6,
        }
      }  
    },
    product_types: {
        flights: 0,
        stays: 1,
        rental_cars: 2,
    },
    bot: {
        prompt_types: {
            warn: "warn",
            prompt: "prompt",
        },
        responses: {
            introduction_greetings: "introduction greetings",
            no_hotel_booking: "no hotel booking",
            no_language_support: "no language support",
            no_currency_support: "no currency support",
            no_cars_renting: "no cars renting",
            no_travel_packages : "no travel packages",
            uncompleted_pnr: "incomplete passenger name record",
            not_logged_in_on_checkout_complete: "checkout completed but user is not logged in",
            click_to_start_flight_booking: "click to start flight booking",
            wait_while_loading: "wait while loading"
        }
    },
    envs: [ "PRODUCTION", "DEVELOPMENT", "STAGE" ],
    is_test_mode: false,
    disabled_features: {
        payment: false,
        stays_search: true,
        rental_car_search: true,
        flight_search: false,
        travel_packages: true,
        bot_aide: {
            chat: false,
            prompts: false,
            settings: true,
            history_page: true,
        },
        user_account: {
            frequent_flyer_and_membership: true,
        }
    },
    customer_fees: {
        package_order: {
            defaults: [
                {
                    name: "Platform Services Fee",
                    total: 5.00,
                    total_currency: "usd",
                },
            ]
        },
        flight_order: {
            defaults: [
                {
                    name: "Platform Services Fee",
                    total: 5.00,
                    total_currency: "usd",
                },
            ]
        },
        get_payment_processor_fee: (total_price=1, vendor="stripe") => {
          let percentage = 1;
          if(vendor.toLowerCase()==="stripe"){
            percentage = 2
          }
          const fee_amount = ((percentage/100)*total_price);
          const name = `Payment Processor Fee (${percentage}%)`
          return {
            name,
            percentage,
            vendor,
            fee_amount,
            total_price
          }
        }
    }
}

export default CONSTANTS;
